import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { QueryState } from '@/components/QueryState'
import { ProductForm } from '@/features/inventory/ProductForm'
import { getProduct } from '@/features/inventory/api'

export function ProductNew() {
  return <ProductForm />
}

export function ProductEdit() {
  const { productId = '' } = useParams()
  const product = useQuery({
    queryKey: ['product', productId],
    queryFn: () => getProduct(productId),
    retry: false,
  })
  return (
    <QueryState isLoading={product.isLoading} error={product.error}>
      {/* Keyed so a different product starts from its own values, not the last one's. */}
      {product.data && <ProductForm key={product.data.id} product={product.data} />}
    </QueryState>
  )
}
